import { combinedApi as api } from "../combinedApi";
export const addTagTypes = ["TimeSynchronisationType"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getTimeSynchronisationType: build.query<
        GetTimeSynchronisationTypeApiResponse,
        GetTimeSynchronisationTypeApiArg
      >({
        query: () => ({ url: `/TimeSynchronisationType` }),
        providesTags: ["TimeSynchronisationType"],
      }),
      getTimeSynchronisationTypeByName: build.query<
        GetTimeSynchronisationTypeByNameApiResponse,
        GetTimeSynchronisationTypeByNameApiArg
      >({
        query: (queryArg) => ({ url: `/TimeSynchronisationType/${queryArg}` }),
        providesTags: ["TimeSynchronisationType"],
      }),
      putTimeSynchronisationTypeByName: build.mutation<
        PutTimeSynchronisationTypeByNameApiResponse,
        PutTimeSynchronisationTypeByNameApiArg
      >({
        query: (queryArg) => ({
          url: `/TimeSynchronisationType/${queryArg.name}`,
          method: "PUT",
          body: queryArg.timeSynchronisationTypeDto,
        }),
        invalidatesTags: ["TimeSynchronisationType"],
      }),
      deleteTimeSynchronisationTypeByName: build.mutation<
        DeleteTimeSynchronisationTypeByNameApiResponse,
        DeleteTimeSynchronisationTypeByNameApiArg
      >({
        query: (queryArg) => ({
          url: `/TimeSynchronisationType/${queryArg}`,
          method: "DELETE",
        }),
        invalidatesTags: ["TimeSynchronisationType"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as timeSynchronisationTypeApi };
export type GetTimeSynchronisationTypeApiResponse =
  /** status 200 OK */ TimeSynchronisationTypeDto[];
export type GetTimeSynchronisationTypeApiArg = void;
export type GetTimeSynchronisationTypeByNameApiResponse =
  /** status 200 OK */ TimeSynchronisationTypeDto;
export type GetTimeSynchronisationTypeByNameApiArg = string;
export type PutTimeSynchronisationTypeByNameApiResponse =
  /** status 200 OK */ void;
export type PutTimeSynchronisationTypeByNameApiArg = {
  name: string;
  timeSynchronisationTypeDto: TimeSynchronisationTypeDto;
};
export type DeleteTimeSynchronisationTypeByNameApiResponse = unknown;
export type DeleteTimeSynchronisationTypeByNameApiArg = string;
export type TimeSynchronisationTypeDto = {
  name: string;
  comment?: string | null;
  isUsed: boolean;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export const {
  useGetTimeSynchronisationTypeQuery,
  useLazyGetTimeSynchronisationTypeQuery,
  useGetTimeSynchronisationTypeByNameQuery,
  useLazyGetTimeSynchronisationTypeByNameQuery,
  usePutTimeSynchronisationTypeByNameMutation,
  useDeleteTimeSynchronisationTypeByNameMutation,
} = injectedRtkApi;
